import React, { useState } from 'react'
import Header from './Header'
import '../assetss/styles/layout.css'
import { Outlet , useLocation } from "react-router-dom";
import Footer from './Footer';
import BeforeFooter from './BeforeFooter';

const Layoute = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [qty, setQty] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const location = useLocation()



  return (
    <main className='relative '>
      <Header searchQuery={searchQuery} cartItems={cartItems} setSearchQuery={setSearchQuery} />
      {/* <Main/> */}
      <div>
        <Outlet context={{ searchQuery, qty, setQty, cartItems, setCartItems }} />
      </div>
      {location.pathname === '/'&&
      <>
      <BeforeFooter />
      <Footer /></>
      }
    </main>
  )
}
export default Layoute